import * as React from "react";
import { connect } from "react-redux";
import * as download from "downloadjs";
import { IStoreState } from "../../redux/rootReducer";
import { logGPXDownloaded } from "../../redux/modules/metrics/reducer";
import Button from "../Generics/Button";
import { createGpxFileAll } from "../../redux/computables/gcpRequest/gpxFile";
import { IGcpAppDispatchProp } from "../../redux/store";

interface IGpxDownloadButtonInitialProps extends IGcpAppDispatchProp {
  gpxFile: string;
}
class GpxDownloadButtonInitial extends React.Component<IGpxDownloadButtonInitialProps> {
  public render() {
    return (
      <Button
        stretched
        type="primary"
        label="GPX"
        icon={<img src="icon-download.svg" />}
        onClick={() => {
          this.props.dispatch(logGPXDownloaded());
          download(this.props.gpxFile, "Flight_Markers.gpx", "text/csv");
        }}
      />
    );
  }
}

export default connect((state: IStoreState) => ({
  gpxFile: createGpxFileAll(state),
}))(GpxDownloadButtonInitial);
